import React, {useEffect, useState} from "react"
import Box from "@mui/material/Box";
import {
    AppBar, Avatar, Divider, Drawer, Grid, IconButton, ListItem, ListItemButton, ListItemIcon,
    ListItemText, Toolbar
} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import Typography from "@mui/material/Typography";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {useLocation} from 'react-router-dom';
import List from "@mui/material/List";
import {useNavigate} from 'react-router-dom';
import ListAltIcon from '@mui/icons-material/ListAlt';
import AssessmentIcon from '@mui/icons-material/Assessment';
import LogoutIcon from '@mui/icons-material/Logout';
import axios from "axios";

const Appbar = ({isMobile}) => {
    const [backbutton, setBackbutton] = React.useState(false);
    const location = useLocation().pathname;
    const [rightMneu, setRightMneu] = React.useState(false);
    const [userImg, setUserImg] = useState("");
    const [userName, setUserName] = useState("");

    useEffect(() => {
        const data = {
            token: localStorage.getItem("token"),
        }
        axios.post("https://app.zhivay.com/api/get_userinfo.php", data)
            .then(response => {
                if (response.status === 200) {
                    if (response.data.error === false) {
                        setUserImg(response.data.image);
                        setUserName(response.data.name);
                    } else {
                        if (response.data.ex_token === true) {
                            localStorage.clear();
                            if (window.location.pathname !== "/login")
                                window.location.href = "/login";
                        }
                    }
                }
            })
            .catch(error => {
                console.log(error)
            });
    }, [])
    useEffect(() => {
        if (location !== "/")
            setBackbutton(true);
    }, '');

    const navigate = useNavigate();
    const handlebottomSheet = (index) => {
        if (index === 0) {
            navigate("/");
            setRightMneu(false);
        }
        if (index === 1) {
            navigate("/factors");
            setRightMneu(false);
        }
        if (index === 2) {
            navigate("/log");
            setRightMneu(false);
        }
        if (index === 3) {
            navigate("/financial_reports");
            setRightMneu(false);
        }
        if (index === 22) {
            navigator.clipboard.writeText('https://zhivay.com/listprice.pdf');
            setRightMneu(false);
        }
        if (index === 33) {
            navigator.clipboard.writeText('https://zhivay.com/listprice_chobplast.pdf');
            setRightMneu(false);
        }
        if (index === 44) {
            navigator.clipboard.writeText('https://zhivay.com/catalog.pdf');
            setRightMneu(false);
        }

    }
    const list = () => (
        <Box
            sx={{textAlign: "center", width: "240px", height: "100vh", backgroundColor: "#ffffff"}}

            onKeyDown={() => {
                setRightMneu(false)
            }}>
            <AppBar
                position="static"
                sx={{backgroundColor: "#34857e"}}>
                <Toolbar title={"asd"} variant={"dense"} sx={{backgroundColor: "#34857e"}}>
                    {isMobile ?
                        <>
                            <IconButton
                                size="large"
                                edge="start"
                                aria-label="menu"
                                onClick={() => {
                                    setRightMneu(false)
                                }}
                                sx={{mr: 2, color: "white"}}>
                                <CloseIcon/>
                            </IconButton>
                            <div style={{textAlign: "right", width: "100%"}}>ژیوای</div>
                        </>
                        : ""
                    }

                </Toolbar>
            </AppBar>
            <Box sx={{direction: "rtl"}}>
                <Grid container>
                    <Grid item xs={9}>
                        <Avatar
                            alt={userName}
                            src={userImg}
                            sx={{width: 50, height: 50, margin: 1}}
                        />
                    </Grid>
                    <Grid item xs={3} sx={{margin: "auto"}}>
                        <IconButton
                            size="large"
                            edge="start"
                            aria-label="menu"
                            onClick={() => {
                                localStorage.clear();
                                window.location.href = "/login";
                            }}
                            sx={{color: "black"}}>
                            <LogoutIcon/>
                        </IconButton>
                    </Grid>
                </Grid>
                {!!userName ?
                    <h5 style={{marginTop: "10px", textAlign: "right", marginRight: "10px"}}>{userName} عزیز خوش
                        آمدید </h5>
                    :
                    <h5 style={{marginTop: "10px", textAlign: "right", marginRight: "10px"}}> عزیز خوش آمدید </h5>
                }
            </Box>

            <Divider/>
            <List sx={{textAlign: "right"}}>
                <ListItem key="0" disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handlebottomSheet(0)
                        }}>
                        <ListItemText sx={{textAlign: "right"}} primary="پیشخوان"/>
                        <ListItemIcon sx={{direction: "rtl"}}><HomeIcon/></ListItemIcon>
                    </ListItemButton>
                </ListItem>
                <ListItem key="1" disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handlebottomSheet(1)
                        }}>
                        <ListItemText sx={{textAlign: "right"}} primary="فاکتور فروش"/>
                        <ListItemIcon sx={{direction: "rtl"}}><ListAltIcon/></ListItemIcon>
                    </ListItemButton>
                </ListItem>
                <ListItem key="1" disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handlebottomSheet(1)
                        }}>
                        <ListItemText sx={{textAlign: "right"}} primary="فاکتور خرید"/>
                        <ListItemIcon sx={{direction: "rtl"}}><ListAltIcon/></ListItemIcon>
                    </ListItemButton>
                </ListItem>
                <ListItem key="3" disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handlebottomSheet(3)
                        }}>
                        <ListItemText sx={{textAlign: "right"}} primary="گزارشات مالی"/>
                        <ListItemIcon sx={{direction: "rtl"}}><AssessmentIcon/></ListItemIcon>
                    </ListItemButton>
                </ListItem>
                <ListItem key="2" disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handlebottomSheet(2)
                        }}>
                        <ListItemText sx={{textAlign: "right"}} primary="گزارشات کاربران"/>
                        <ListItemIcon sx={{direction: "rtl"}}><AssessmentIcon/></ListItemIcon>
                    </ListItemButton>
                </ListItem>
                <ListItem key="22" disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handlebottomSheet(22)
                        }}>
                        <ListItemText sx={{textAlign: "right"}} primary="لیست قیمت"/>
                        <ListItemIcon sx={{direction: "rtl"}}><FileCopyIcon/></ListItemIcon>
                    </ListItemButton>
                </ListItem>

            </List>
        </Box>
    );
    return (
        <Box sx={{flexGrow: 1, marginBottom: 8}}>
            <AppBar position="fixed" dir="rtl" sx={{backgroundColor: "#34857e"}}>
                <Toolbar variant={"dense"} sx={{backgroundColor: "#34857e"}}>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        sx={{mr: 2, direction: "rtl", marginRight: 0}}
                        onClick={() => {
                            setRightMneu(true)
                        }}>
                        <MenuIcon/>
                    </IconButton>
                    <Typography variant="h6" sx={{flexGrow: 1, textAlign: "center"}}>
                        هلدینگ ژیوای
                    </Typography>
                    {backbutton ?
                        <IconButton
                            aria-label="back"
                            color="inherit"
                            onClick={() => window.history.back()}>
                            <ArrowBackIcon/>
                        </IconButton>
                        : ''}
                </Toolbar>
            </AppBar>
            <Drawer
                anchor="right"
                open={rightMneu}
                variant={!isMobile ? "permanent" : ""}
                PaperProps={{
                    sx: {
                        backgroundColor: "transparent",
                    }
                }}
                onClose={() => {
                    setRightMneu(false)
                }}>
                {list()}
            </Drawer>
        </Box>
    )
}
export default Appbar